import { toast } from 'react-toastify';

/**
 * Handles HTTP errors and displays a friendly message to the user.
 * @param error The error object from an Axios request or similar.
 */
export const handleHttpError = (error: unknown): void => {
  const status = (error as any)?.response?.status;
  const serverMessage = (error as any)?.response?.data?.message;

  const messages: Record<number, string> = {
    400: serverMessage || 'Requisição inválida. Verifique os dados e tente novamente.',
    401: 'Sessão expirada ou não autenticada. Faça login para continuar.',
    403: 'Acesso negado. Você não tem permissão para realizar essa ação.',
    404: 'Recurso não encontrado. Verifique o endereço ou tente mais tarde.',
    409: serverMessage || 'Conflito de dados. Pode ser um registro duplicado ou em uso.',
    422: 'Dados inválidos. Corrija os campos e tente novamente.',
    429: 'Muitas requisições. Aguarde um momento e tente novamente.',
    500: 'Erro interno no servidor. Estamos trabalhando para resolver.',
    502: 'Erro de gateway. O servidor recebeu uma resposta inválida.',
    503: 'Serviço temporariamente indisponível. Tente novamente em instantes.',
    504: 'Tempo de resposta esgotado. Verifique sua conexão e tente novamente.',
  };

  if (status && messages[status]) {
    const msg = messages[status];
    const isWarn = [401, 403, 429, 503].includes(status);
    isWarn ? toast.warn(msg) : toast.error(msg);
  } else {
    console.error('Unhandled error:', error);
    toast.error('Ocorreu um erro inesperado. Tente novamente mais tarde.');
  }
};
